/**
 * Maps lock overview API status strings to CSS class keys and display labels.
 * Shared by LockOverview and future dashboard widgets (P3).
 */

const STATUS_CLASS_MAP = {
  won: 'won',
  lost: 'lost',
  winning: 'winning',
  losing: 'losing',
  'in progress': 'in-progress',
  future: 'future',
  unknown: 'unknown',
};

const STATUS_LABEL_MAP = {
  won: 'Won',
  lost: 'Lost',
  winning: "W'ing",
  losing: "L'ing",
  'in progress': 'Live',
  future: 'Future',
  unknown: 'Unknown',
};

export const normalizeLockStatusKey = (status) => {
  if (!status || typeof status !== 'string') {
    return 'unknown';
  }

  const normalized = status.trim().toLowerCase();

  if (normalized === 'lost' && status === 'Lost') {
    // no_pick also returns 'Lost' from backend — distinguish if needed later
  }

  return STATUS_CLASS_MAP[normalized] || 'unknown';
};

export const getLockStatusClassName = (status) => {
  return `status-${normalizeLockStatusKey(status)}`;
};

export const formatLockStatusLabel = (status) => {
  if (!status || typeof status !== 'string') {
    return '-';
  }

  const normalized = status.trim().toLowerCase();
  return STATUS_LABEL_MAP[normalized] || status;
};

export const normalizeGameStatusKey = (gameStatus, kickoff) => {
  if (gameStatus === 'in_progress') return 'in_progress';
  if (gameStatus === 'completed') return 'completed';
  if (gameStatus === 'scheduled' && kickoff && new Date(kickoff) > new Date()) {
    return 'scheduled';
  }
  return gameStatus || null;
};

export const formatLiveGameClock = (period, clock) => {
  if (period == null || !clock) {
    return null;
  }

  const quarterNames = {
    1: '1st',
    2: '2nd',
    3: '3rd',
    4: '4th',
    5: 'OT',
  };

  const quarter = quarterNames[period] || `${period}th`;
  return `${quarter} • ${clock}`;
};

export const isLiveGameStatus = (gameStatus) => gameStatus === 'in_progress';

export const isLiveLockStatus = (status) => {
  const key = normalizeLockStatusKey(status);
  return key === 'winning' || key === 'losing' || key === 'in-progress';
};

/** Bye weeks (and no-pick rows) are not game outcomes — hide W/L/Future status. */
export const shouldDisplayLockStatus = (lock) => {
  if (!lock?.status) return false;
  if (lock.lock === 'Bye Week' || lock.lock === 'No Pick') return false;
  return true;
};
